import { DateTime } from "luxon"
import { Grid, Stack, Typography } from "@mui/material"

import { FormikTimePicker } from "../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../localization/useDateTime"

import type { TimeOfDayInterval } from "../productGroupAvailability"

type TimeIntervalFieldProps = Readonly<{
    groupTimeInterval: TimeOfDayInterval | undefined
}>

export function TimeIntervalField({ groupTimeInterval }: TimeIntervalFieldProps) {
    const dateTimeFactory = useDateTime()
    const groupHours = groupTimeInterval && {
        start: dateTimeFactory.formatTime(groupTimeInterval.start),
        end: dateTimeFactory.formatTime(groupTimeInterval.end),
    }

    return (
        <Stack spacing=".5rem">
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <LocalizedStrict id="product-create-availability-from-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<never, DateTime>
                            name="availabilityDetails.timeInterval.start"
                            label="From time"
                            minTime={groupTimeInterval?.start}
                            maxTime={groupTimeInterval?.end}
                            slotProps={{ field: { clearable: true } }}
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={6}>
                    <LocalizedStrict id="product-create-availability-to-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<never, DateTime>
                            name="availabilityDetails.timeInterval.end"
                            label="To time"
                            minTime={groupTimeInterval?.start}
                            maxTime={groupTimeInterval?.end}
                            slotProps={{ field: { clearable: true } }}
                        />
                    </LocalizedStrict>
                </Grid>
            </Grid>
            {groupHours ? (
                <LocalizedStrict id="product-create-availability-time-group-helper-text" vars={groupHours}>
                    <Typography variant="body2" color="text.secondary">
                        Must be within the product group's hours, {groupHours.start} – {groupHours.end}. Leave both
                        times empty to use the product group's hours.
                    </Typography>
                </LocalizedStrict>
            ) : (
                <LocalizedStrict id="product-create-availability-time-helper-text">
                    <Typography variant="body2" color="text.secondary">
                        Leave both times empty to sell the product all day.
                    </Typography>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
